import api from '../../api';

export default {

  ADD_FILE: ({ commit }, { file, bucket }) => {
    commit('ADD_FILE', { file, bucket });
  },

  DELETE_BUCKET: ({ commit }, { bucket }) => {
    commit('DELETE_BUCKET', { bucket });
  },

  SET_FILE_STATUS: ({ commit }, { filename, bucket, status }) => {
    commit('SET_FILE_STATUS', { filename, bucket, status });
  },

  SET_FILE_DATA: ({ commit }, { filename, bucket, data }) => {
    commit('SET_FILE_DATA', { filename, bucket, data });
  },

  DELETE_FILE: ({ commit }, { filename, bucket }) => {
    commit('DELETE_FILE', { filename, bucket });
  },

};


// WEBPACK FOOTER //
// ./src/store/uploader/actions.js